import map from 'lodash/map';

import { Skill } from 'src/actions/skills/skillsResource';
import { SkillAncestry } from 'src/actions/skills/skillHierarchyResource';
import { Ancestry, HierarchicalItem, sortMergedItems } from 'src/lib/hierarchy';

export function skillHierarchyToAncestries(skillHierarchy: SkillAncestry[]): Ancestry[] {
  return map(skillHierarchy, ({ skillId, ancestralSkillId }) => {
    return {
      itemId: skillId,
      ancestorId: ancestralSkillId,
    };
  });
}

export function sortMergedSkills({
  skillHierarchy,
  skills,
}: {
  skillHierarchy: { values: SkillAncestry[] };
  skills: { values: Skill[] };
}): HierarchicalItem<Skill>[] {
  const hierarchy = skillHierarchyToAncestries(skillHierarchy.values);

  return sortMergedItems(hierarchy, skills.values);
}
